<template>
  <div class="mx-auto mt-3 ">
    <p
      class="subtitle-2 font-weight-bold grey--text text--darken-2 text-center"
    >
      {{ SubCatArt($route.params.codart) }}
    </p>
    
    <v-sheet class="mx-auto pa-1 menu" elevation="0" max-width="700">
      <v-slide-group v-model="model" center-active show-arrows>
        <v-slide-item
          v-for="item in tempdata"
          :key="item.Codigo"
          v-slot="{ active }"
         
        >
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-card
                :color="active ? 'grey' : 'grey lighten-1'"
                class="ma-1"
                height="50"
                width="50"
                :style="codArt != item.Codigo ? 'cursor:pointer' : 'cursor:not-allowed'"
                @click="codArt != item.Codigo ? irTo(item.Codigo) : null"
              >
                <v-avatar tile size="50" class="mx-auto">
                  <v-img contain :src="imgArt(item.Codigo)"></v-img>
                </v-avatar>
                <v-fade-transition>
                  <v-overlay 
                  v-if="!hover" 
                  absolute 
                  :color="codArt != item.Codigo ? '#E0E0E0' : '#616161'">
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </template>
          </v-hover>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  props: {
    codArt: String,
  },
  data() {
    return {
      model: null,
      tempdata: [],
      overlay: true,
    };
  },
  computed: {
    ...mapState(["imgPeque", "Articulo"]),
    SubCatArt: function() {
      return function(id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.NombreSubCat)
            .toString();
        }
      };
    },
  },
  methods: {
      ...mapMutations(["CLR_DATOS_ART", "clr_page"]),
     ...mapActions(["cargarDatosPromo","cargarFeature",
      "cargarDatosArt"]),
    irTo(codart) {
       let xart=encodeURIComponent(codart);
         this.$router.push({ path: `/articulo/${xart}` }).catch((err) => {});
       this.cargarDatosPromo({ codart: codart });
        this.cargarDatosArt({ codart: codart });
this.clr_page()
        this.cargarFeature({
          articulo: codart,
          cia: 1,
          opc: 8,
        });
        this.CLR_DATOS_ART();

    },
    imgArt(id) {
      let urlImg = null;

      let nb = this.tempdata
        .filter((x) => x.Codigo === id)
        .map((x) => x.Imagen);
      urlImg = `${this.imgPeque}${nb.toString()}`;

      return urlImg;
    },
  },
  mounted() {
    if (window.localStorage.getItem("datosgrid")) {
      try {
        //  this.tempdata = localStorage.getItem('datosgrid');
        this.tempdata = JSON.parse(window.localStorage.getItem("datosgrid"));
      } catch (e) {
        // localStorage.removeItem('datosgrid');
      }
    }
  },
};
</script>

<style scoped>
.menu{
  height: 100%;
  position: sticky;
  top: 100px;
}
</style>
